module.exports = __webpack_public_path__ + "static/media/sean-pollock-PhYq704ffdA-unsplash 1.deac0a8f.png";